export default __webpack_public_path__ + "257d9da68be710af1f964d92ef372818.svg";